import { render, staticRenderFns } from "./VesselsLoop.vue?vue&type=template&id=71484586&scoped=true"
import script from "./VesselsLoop.vue?vue&type=script&lang=js"
export * from "./VesselsLoop.vue?vue&type=script&lang=js"
import style0 from "./VesselsLoop.vue?vue&type=style&index=0&id=71484586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71484586",
  null
  
)

export default component.exports